import React, { useState, useEffect, Fragment } from "react";
import {
  Row,
  Col,
  CardBody,
  Card,
  Table,
  Input
} from "reactstrap";
import i18n from "../../../i18n";
import SimpleAlertError from "../../../components/Alerts/SimpleAlertError";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { patchUnassignServices } from "../../../helpers/api_rombo_helper";
import Paginations from "../../../components/Common/Pagination";
import Spinners from "../../../components/Common/Spinner";
import Select from "react-select";
import { map } from "lodash";
import { WebsocketDrivers } from "../AssignService/WebsocketDrivers";
import { DataActions, DriverStatus } from "../../../constants/enums";

const Step1 = ({ step, setStep, token, infoUser, services, setServices, setServicesError, note, setNote, setIsNoteValid, isNoteValid }) => {

  const dispatch = useDispatch();

  const [errorAlert, setErrorAlert] = useState(false);
  const [isLoading, setLoading] = useState(true);
  const [servicesSuccess, setServicesSuccess] = useState(true);
  const [errorAlertMessage, setErrorAlertMessage] = useState(null);
  const [listDrivers, setListDrivers] = useState({ items: [] });
  const [formatDrivers, setFormatDrivers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage] = useState(7);
  
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = services.slice(indexOfFirstRecord, indexOfLastRecord);
  const nPages = Math.ceil(services.length / recordsPerPage);
  
  const [filtersOpts, setFiltersOpts] = useState({
    eventType: "sendMessage",
    metadata: { platform: "WEB" },
    data: { action: DataActions.GET_DRIVERS, filters: { page: 1, size: 10, status: DriverStatus.ALL } }
  });

  useEffect(() => {
    let onServices = JSON.parse(localStorage.getItem("services")) || [];
    onServices.sort((a, b) => a.code.localeCompare(b.code));
    setServices(onServices);

    return () => {
      localStorage.removeItem("services");
    };
  }, [dispatch]);

  useEffect(() => {
    let arr = [{ label: i18n.t("Unassigned"), value: i18n.t("Unassigned"), sub: null }];
    let platesServices = services.map((e) => e.plate);

    listDrivers.items.map((item) => {
      if (!platesServices.includes(item.vehicle.plate)) {
        arr.push({
          label: item.vehicle.plate,
          value: item.vehicle.plate,
          sub: item.driver.sub,
        });
      }
    });

    setFormatDrivers([...arr]);
  }, [listDrivers, services]);

  useEffect(() => {
    let flag = false;
    services.map((item) => item.subDriver ? null : flag = true);
    setServicesSuccess(flag);
  }, [services]);

  const onChangePlate = (service, e) => {
    const updatedServices = [...services];
    const updatedFormatDrivers = [...formatDrivers];
    const serviceToUpdate = updatedServices.find((item) => item.code === service.code);
  
    if (serviceToUpdate) {
      if (serviceToUpdate.plate && serviceToUpdate.plate !== i18n.t("Unassigned")) {
        updatedFormatDrivers.push({
          label: serviceToUpdate.plate,
          value: serviceToUpdate.plate,
          sub: serviceToUpdate.subDriver,
        });
      }
  
      serviceToUpdate.plate = e.value;
      serviceToUpdate.subDriver = e.value === i18n.t("Unassigned") ? null : e.sub;
      serviceToUpdate.nameDriver = e.value === i18n.t("Unassigned") ? null : e.sub;
  
      const selectedDriver = updatedFormatDrivers.find((item) => item.value === e.value);
      if (selectedDriver) {
        updatedFormatDrivers.splice(updatedFormatDrivers.indexOf(selectedDriver), 1);
      }
  
      updatedServices.sort((a, b) => a.code.localeCompare(b.code));
      setServices(updatedServices);
      setFormatDrivers(updatedFormatDrivers);
    }

  };
  
  const onClickNextStep = () => {
    const unassignedServices = services.filter((item) => item.plate === i18n.t("Unassigned"));
  
    if (unassignedServices.length > 0) {
      const unassignBody = {
        codes: unassignedServices.map((item) => item.code),
        unassign_info: { reason: note },
      };
  
      patchUnassignServices(token, unassignBody)
        .then(() => {
          setServices(
            services.map((item) => {
              if (item.plate === i18n.t("Unassigned")) {
                item.status.key = "UNASSIGNED";
                item.status.value = i18n.t("Unassigned");
              }
              return item;
            })
          );
          setStep(step + 1);
        })
        .catch((error) => {
          console.error("Error - patchUnassignServices - ", error);
          if (error?.response?.status === 409) {
            setErrorAlert(true);
            setErrorAlertMessage(i18n.t("ServiceStartedError"));
          } else {
            setErrorAlert(true);
            setErrorAlertMessage(i18n.t("NetworkError"));
          }
        });
    }
  };      

  return (
    <Fragment>
      <CardBody>
        <SimpleAlertError
          errorAlert={errorAlert}
          setErrorAlert={setErrorAlert}
          text={errorAlertMessage}
        />
        <Row>
          <Col xxl={12} md={12} xs={12}>
            <h5>{i18n.t("EditServiceAssignment")}</h5>
            <p className="request-create-text text-margin-bottom">{i18n.t("SelectANewPlate")}</p>
          </Col>
          <div className="table-responsive pt-3 relative overflow-x-auto shadow-md sm:rounded-lg">
            <div className="modal-separator" />
            <p/>
            <Table className="table table-responsive border table-assignment-services">
              <thead>
                <tr>
                  <th className="bg-light request-number-column table-header-text">{i18n.t("ID")}</th>
                  <th className="bg-light origin-column table-header-text">{i18n.t("Origin")}</th>
                  <th className="bg-light destination-column table-header-text">{i18n.t("Destiny")}</th>
                  <th className="bg-light date-column table-header-text">{i18n.t("Date")}</th>
                  <th className="bg-light hour-column table-header-text">{i18n.t("Hour")}</th>
                  <th className="bg-light status-column table-header-text">{i18n.t("Status")}</th>
                  <th className="bg-light plates-column table-header-text">{i18n.t("Plate")}</th>
                </tr>
              </thead>
              {isLoading ? null : (
                <tbody>
                  {map(currentRecords, (item, key) => (
                    <tr key={key}>
                      <td>{item.code}</td>
                      <td>{item.origin.address.description}</td>
                      <td>
                        {item.destination?.address?.description || ""}
                      </td>
                      <td>{item.scheduled_start.date}</td>
                      <td>{item.scheduled_start.time}</td>
                      <td>
                        <p className={`bg-${item.status.key.toLowerCase()} text-white rounded-2 text-center p-1 fs-10`}>
                          {`${item.status.value}`}
                        </p>
                      </td>
                      <td>
                      <Card>
                        <Select
                          name="plate"
                          placeholder={i18n.t("SelectPlate")}
                          options={[{ label: i18n.t("Unassigned"), value: i18n.t("Unassigned") }]}
                          isDisabled={item.disabled} 
                          className="select2-selection"
                          onChange={(e) => onChangePlate(item, e)} 
                          value={{
                            label: item.plate && item.plate !== i18n.t("Unassigned") ? item.plate : i18n.t("Unassigned"),
                            value: item.plate && item.plate !== i18n.t("Unassigned") ? item.plate : i18n.t("Unassigned"),
                            sub: item.subDriver,
                          }}
                          maxMenuHeight={120}
                        />
                      </Card>
                      </td>
                    </tr>
                  ))}
                </tbody>
              )}
            </Table>
            {isLoading ? (
              <Spinners setLoading={setLoading} />
            ) : (
              nPages > 1 && (
                <Paginations
                  perPageData={recordsPerPage}
                  data={services}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  isShowingPageLength={false}
                  paginationDiv="col-lg-12"
                  paginationClass="pagination pagination-rounded justify-content-center mt-3 mb-4 pb-1"
                />
              )
            )}
            <div className="modal-separator" />
          </div>
          <WebsocketDrivers
            setLoading={setLoading}
            filtersOpts={filtersOpts}
            uuid={infoUser.external_id}
            listDrivers={listDrivers}
            setListDrivers={setListDrivers}
          />
          <p/>
          <h5>{i18n.t("ReasonForEditing")}</h5>
          <p className="request-create-text text-margin-bottom">{i18n.t("WriteANote")}</p>
          <p/>
          <Col xxl={6} md={6} xs={12} className="pt-3 d-flex">
          <Input
            type="textarea"
            className="form-control"
            placeholder={i18n.t("WriteYourNoteHere")}
            value={note}
            onChange={(e) => {
              setNote(e.target.value);
              setIsNoteValid(e.target.value.trim() !== "");
            }}
          />
          </Col>
          <Col xxl={12} md={12} xs={12} className="pt-3 d-flex">
            <button
              onClick={() => onClickNextStep()}
              disabled={!isNoteValid}
              className="btn btn-request"
            >
              {i18n.t("NextStep")}
            </button>
            <Link to="/services/reservations" className="btn btn-go-back mx-2">
              {i18n.t("GoBack")}
            </Link>
          </Col>
        </Row>
      </CardBody>
    </Fragment>
  );
};

export default Step1;
